module.exports = __webpack_public_path__ + "static/logo-c9d7f155ac384439ef1a3d260172bc3c.png";